"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SmartContractApi_apiClient, _SmartContractApi_rpcApi;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartContractApi = void 0;
const Error_1 = require("../Error");
const SmartContract_1 = require("../model/SmartContract");
const RpcApi_1 = require("./RpcApi");
class SmartContractApi {
    constructor(apiClient) {
        _SmartContractApi_apiClient.set(this, void 0);
        _SmartContractApi_rpcApi.set(this, void 0);
        this.get = async (props) => {
            const result = await __classPrivateFieldGet(this, _SmartContractApi_apiClient, "f").get(`/v1/smart-contracts/${props.id}`);
            if (result.ok) {
                const rpc = await __classPrivateFieldGet(this, _SmartContractApi_rpcApi, "f").getOrCreate({
                    organizationId: result.data.organizationId,
                    chainId: result.data.chainId,
                    wallet: props.wallet?.address,
                });
                return SmartContract_1.SmartContract.fromDto(result.data, this, rpc.url, props.wallet);
            }
            throw new Error_1.KriptonioError({
                message: `error while fetching smart contract with id ${props.id}. ${result.error.stringify()}`,
            });
        };
        this.createFromStandardJson = async (props) => {
            const result = await __classPrivateFieldGet(this, _SmartContractApi_apiClient, "f").post('/v1/smart-contracts/standard-json', { data: props.data });
            if (result.ok) {
                return this.get({ id: result.data.id, wallet: props.wallet });
            }
            throw new Error_1.KriptonioError({
                message: `error while creating smart contract. ${result.error.stringify()}`,
            });
        };
        this.createDeployment = async (props) => {
            const result = await __classPrivateFieldGet(this, _SmartContractApi_apiClient, "f").post(`/v1/smart-contracts/${props.id}/deployment`, { data: props.data });
            if (result.ok) {
                return result.data;
            }
            throw new Error_1.KriptonioError({
                message: `error while creating smart contract deployment. ${result.error.stringify()}`,
            });
        };
        this.updateDeploymentTransaction = async (id, hash, data) => {
            const result = await __classPrivateFieldGet(this, _SmartContractApi_apiClient, "f").put(`/v1/smart-contracts/${id}/transactions/${hash}`, { data });
            if (result.ok) {
                return result.data;
            }
            throw new Error_1.KriptonioError({
                message: `error while updating smart contract deployment transaction. ${result.error.stringify()}`,
            });
        };
        __classPrivateFieldSet(this, _SmartContractApi_apiClient, apiClient, "f");
        __classPrivateFieldSet(this, _SmartContractApi_rpcApi, new RpcApi_1.RpcApi(apiClient), "f");
    }
}
exports.SmartContractApi = SmartContractApi;
_SmartContractApi_apiClient = new WeakMap(), _SmartContractApi_rpcApi = new WeakMap();
